<template>
  <div class="container" v-if="loaded">
    <line-chart :chart-data="data" :width="3000" :height="1000"></line-chart>
  </div>
</template>

<script>

import LineChart from '../components/Chart.vue';

export default {
  name: 'Rating',

  components: {
    LineChart,
  },

  data: () => ({
    data: {
      labels: [],
      datasets: [{
        label: 'ratings',
        data: [],
        borderColor: [
          'rgba(54, 162, 235, 1)',
        ],
        borderWidth: 1,
      }],
    },

    loaded: false,
  }),

  created() {
    this.$requestHelpers
      .get('api/admin/poi/getRatings')
      .then((response) => {
        this.data.datasets[0].data = response.data.result
          .map((e) => e.ranking).filter((e) => !!e).sort((a, b) => a - b);
        this.data.labels = this.data.datasets[0].data;
        this.loaded = true;
      });
  },
};
</script>

<style scoped>

</style>
